/**
 * Specialty slug — must stay identical to apps/api/src/lib/specialties.ts
 * (slugifySpecialty), which produces the /directory/:specialtySlug URLs.
 * "&" becomes "and": "Gastroenterology & Hepatology" →
 * "gastroenterology-and-hepatology".
 */
export function slugifySpecialty(value: string | null | undefined): string {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replaceAll("&", " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}
